<!--通用表格组件，具有分页功能-->
<template>
  <div class="ny-table">
    <el-table
      style="width: 100%"
      v-loading="page.loading"
      v-bind="$attrs"
      :data="page.data"
      :row-style="rowStyle"
      @cell-click="handleCellClick"
      @selection-change="handleSelectionChange"
    >
      <template v-if="selection">
        <el-table-column type="selection" width="55"></el-table-column>
      </template>
      <slot name="firstColumn"></slot>
      <el-table-column
        v-for="(value, key) in page.header"
        :key="key"
        :prop="key"
        :label="value"
        :fixed="fixedColumns[key]"
        :width="!_isEmptyObject(widthColumns) ? widthColumns[key] : ''"
        :min-width="minWidthColumns[key]"
        :show-overflow-tooltip="true"
        align="center"
      >
        <template slot-scope="{ row, column, index }">
          <slot
            v-if="slotColumns.indexOf(key) > -1"
            :name="key"
            v-bind="{ props: $attrs, row, column, index }"
          >{{row[key]}}</slot>
          <div v-else>
            <template v-if="judgeOfType(row[key]) === 'object'">
              <img v-if="row[key].type === 'IMG'" :src="row[key].value" />
              <video
                ref="video"
                v-else-if="row[key].type === 'VIDEO'"
                controls
                :src="row[key].value"
              ></video>
              <span
                v-else-if="row[key].type === 'ICON'"
                class="icon iconfont"
                :class="row[key].value"
              ></span>
              <a
                v-else-if="row[key].type === 'URL'"
                :href="row[key].value"
                target="_blank"
              >{{row[key].value}}</a>
              <span v-else>{{row[key].value}}</span>
            </template>
            <template v-else>
              <img v-if="regexpImage.test(row[key])" :src="row[key]" />
              <video ref="video" v-else-if="regexpVideo.test(row[key])" controls :src="row[key]"></video>
              <span
                v-else-if="regexpIcon.test(row[key])"
                class="icon iconfont"
                :class="`${row[key].replace(regexpIcon, '')}`"
              ></span>
              <a v-else-if="regexpUrl.test(row[key])" :href="row[key]" target="_blank">{{row[key]}}</a>
              <span v-else>{{row[key]}}</span>
            </template>
          </div>
        </template>
      </el-table-column>
      <slot name="operate"></slot>
      <slot></slot>
    </el-table>
    <template v-if="pagination && page.data.length">
      <el-pagination
        :current-page.sync="page.currentPage"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total,sizes,prev,pager,next,jumper"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </template>
  </div>
</template>

<script>
import { REGEXP_URL, REGEXP_IMAGE, REGEXP_ICON, REGEXP_VIDEO } from '@/global/util/constants';
import { _typeof } from '@/global/util/util'

export default {
  name: 'NyTable',
  props: {
    page: {
      type: Object,
      default: function () {
        return {
          header: [],
          data: [],
          pageSize: 10,
          currentPage: 0,
          loading: true
        };
      },
      required: true
    },
    pagination: {
      type: Boolean,
      default: true
    },
    selection: Boolean,
    fixedColumns: {
      type: Object,
      default () {
        return {}
      }
    },
    widthColumns: {
      type: Object,
      default () {
        return {}
      }
    },
    slotColumns: {
      type: Array,
      default () {
        return []
      }
    },
    minWidthColumns: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      pageSizes: [10, 20, 50],
      regexpUrl: REGEXP_URL,
      regexpImage: REGEXP_IMAGE,
      regexpIcon: REGEXP_ICON,
      regexpVideo: REGEXP_VIDEO,
      judgeOfType: _typeof
    };
  },
  methods: {
    _isEmptyObject: function (obj) {
      var name;

      for (name in obj) {
        return false;
      }
      return true;
    },
    rowStyle ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return { 'background-color': '#f9f9f9' };
      }
    },
    handleCellClick (row, column, cell, event) {
      if (this.$refs.video && this.$refs.video.length) this.$refs.video.forEach(video => video.pause())
      this.$emit('cell-click', { row, column, cell, event });
    },
    handleSelectionChange (row) {
      this.$emit('select-change', row);
    },
    handleSizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.$emit('size-change', {
        pageSize,
        currentPage: this.page.currentPage
      });
    },
    handleCurrentChange (currentPage) {
      this.page.currentPage = currentPage;
      this.$emit('current-change', {
        currentPage,
        pageSize: this.page.pageSize
      });
    }
  }
};
</script>
